import { AppState } from '@/store';
import { Breakpoints } from '@settings';
import { TSortOrder } from '@types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { useMediaQuery } from 'react-responsive';
import FilterModal from '@/components/rtic/FilterModal';
import SortModal from '@/components/rtic/SortModal';
import { filtersAdd } from '../redux/partner.actions';
import { MdClose, MdOutlineTune } from 'react-icons/md';
import { TextInput, Button } from '@components/tailwind';
import { BsFilterLeft } from 'react-icons/bs';
import Sidebar from './sidebar';
import classNames from 'classnames';

const sortOptions = [
  {
    value: TSortOrder.MOST_POPULAR,
    text: 'Most Popular',
  },
  {
    value: TSortOrder.A_TO_Z,
    text: 'A to Z',
  },
  {
    value: TSortOrder.Z_TO_A,
    text: 'Z to A',
  },
  {
    value: TSortOrder.PRICE_HIGH_TO_LOW,
    text: 'Price: High to Low',
  },
  {
    value: TSortOrder.PRICE_LOW_TO_HIGH,
    text: 'Price: Low to High',
  },
];

const ProductsListActions = ({ productsCount }) => {
  const dispatch = useAppDispatch();
  const { sortOrder } = useSelector((state: AppState) => state.partner.filterOptions);
  const isMobView = useMediaQuery({ maxWidth: Breakpoints.MD });
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [sortModalOpen, setSortModalOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState('');

  const openModal = (setter) => () => {
    document.body.classList.add('no-scroll');
    setter(true);
  };

  const renderedSearchInput = (
    <div className='tw-mb-0 tw-flex tw-items-center'>
      <input
        type='text'
        inputMode='text'
        placeholder='Search...'
        onChange={(e) => setSearchInputValue(e.target.value)}
        value={searchInputValue ?? ''}
        className='tw-ml-0 tw-h-8 tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-pr-7 tw-font-body tw-text-xs tw-font-bold tw-transition tw-duration-300 hover:tw-border-gray-400 focus:tw-border-primary focus:tw-outline-none lg:tw-max-w-[170px]'
      />

      {searchInputValue && (
        <MdClose
          size={24}
          className='tw-relative -tw-ml-6 tw-mt-[10px] tw-cursor-pointer tw-p-1 tw-transition tw-duration-300 hover:tw-opacity-70 lg:tw-mt-0'
          onClick={() => setSearchInputValue('')}
        />
      )}
    </div>
  );

  const updateSortOptionsHandler = (e) => {
    onSortSelectOption(e.target.value);
  };

  const onSortSelectOption = (value) => {
    dispatch(filtersAdd('sortOrder', value));
  };

  useEffect(() => {
    const searchTimeout = setTimeout(() => {
      dispatch(filtersAdd('search', searchInputValue));
    }, 350);

    return () => {
      clearTimeout(searchTimeout);
    };
  }, [searchInputValue]);

  return (
    <div id='productsListHeader' className='tw-mb-4'>
      <div className='tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 lg:tw-flex-nowrap'>
        <div className='tw-w-[33%-11px]'>
          <div className='lg:tw-hidden'>
            <Button variant='tertiary' size='xs' onClick={openModal(setFilterModalOpen)}>
              <div className='tw-inline-flex tw-items-center tw-gap-2'>
                <MdOutlineTune size={18} />
                <span>Filter</span>
              </div>
            </Button>
            <FilterModal
              toggleHandler={setFilterModalOpen}
              className={classNames('lg:tw-hidden', {
                'tw-hidden': !filterModalOpen,
              })}>
              <Sidebar />
            </FilterModal>
          </div>
          <div className='tw-hidden lg:tw-block'>{renderedSearchInput}</div>
        </div>
        <div className='tw-w-[34%-11px]'>
          {(!!productsCount || productsCount === 0) && (
            <p className='tw-mb-0 tw-text-center tw-font-body tw-text-[13px] tw-font-normal tw-text-gray-dark'>
              {productsCount} Results
            </p>
          )}
        </div>
        <div className='tw-w-[33%-11px]'>
          <div className='lg:tw-hidden'>
            <Button variant='tertiary' size='xs' onClick={openModal(setSortModalOpen)}>
              <div className='tw-inline-flex tw-items-center tw-gap-2'>
                <BsFilterLeft size={18} />
                <span>Sort</span>
              </div>
            </Button>

            <SortModal
              className={classNames('lg:tw-hidden', {
                'tw-hidden': !sortModalOpen,
              })}
              toggleHandler={setSortModalOpen}
              sortOptions={sortOptions}
              onSelectOption={onSortSelectOption}
              selectedOption={sortOrder}
            />
          </div>
          <select
            onChange={updateSortOptionsHandler}
            value={sortOrder}
            name='sortBy'
            id='sortBy'
            className='tw-hidden tw-h-8 tw-w-full tw-cursor-pointer tw-rounded-md tw-border tw-border-neutrals-light-grey tw-bg-white tw-px-3 tw-pr-2 tw-font-body tw-text-xs tw-font-bold tw-transition tw-duration-300 hover:tw-border-neutrals-medium-grey focus:tw-border-primary focus:tw-outline-none  lg:tw-block lg:tw-max-w-[170px]'>
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
        </div>
        <div className='tw-w-full lg:tw-hidden'>{renderedSearchInput}</div>
      </div>
    </div>
  );
};

export default ProductsListActions;
